import { ColumnExtendedStrict } from '../../types/ColumnExtended';
import { dateHeader, formatCellDate } from './timeModeCell';
import { linkTo } from '../linkTo';

export const makeProcessedSightingColumn = (enableDeepLinks: boolean) => {
  const col: ColumnExtendedStrict<any>[] = [
    {
      header: 'Serial Number',
      accessorKey: 'serialNumber',
      enableColumnFilter: true,
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row }) =>
        enableDeepLinks && row.original.equipmentId
          ? linkTo('/equipment', row.original.equipmentId, row.original.serialNumber)
          : row.original.serialNumber,
    },
    {
      header: 'Station',
      accessorKey: 'stationIataCode',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
    },
    {
      header: 'Facility',
      accessorKey: 'facilityName',
      enableColumnFilter: true,
      size: 275,
      style: { textAlign: 'left', whiteSpace: 'break-spaces' },
      cell: ({ row }) => row.original.facilityName,
    },
    {
      header: 'Reader',
      accessorKey: 'imei',
      enableColumnFilter: true,
      size: 150,
      style: { textAlign: 'center' },
      cell: ({ row }) => (enableDeepLinks ? linkTo('/readers', row.original.imei, row.original.imei) : row.original.imei),
    },
    {
      header: 'ULD Status',
      accessorKey: 'equipmentStatus',
      enableColumnFilter: false,
      size: 80,
      style: { textAlign: 'center' },
      cell: ({ row }) => row.original.equipmentStatusDescr,
    },

    {
      header: 'Network',
      accessorKey: 'networkCarrierCode',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
    },
    {
      header: 'ULD Cond.',
      accessorKey: 'condition',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
    },
    {
      header: dateHeader('Last Seen'),
      accessorKey: 'lastSeenDateTime',
      enableColumnFilter: false,
      style: { textAlign: 'center' },
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.lastSeenDateTime),
    },
    {
      header: dateHeader('Paired'),
      accessorKey: 'pairedDateTime',
      enableColumnFilter: false,
      style: { textAlign: 'center' },
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.pairedDateTime),
    },
    {
      header: 'Rssi',
      accessorKey: 'rssi',
      enableColumnFilter: false,
      size: 40,
      style: { textAlign: 'center' },
    },
    {
      header: 'Battery',
      accessorKey: 'batteryPercent',
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const percentage = row.original.batteryPercent ?? 0;
        const color = percentage >= 80 ? 'green' : percentage <= 20 ? 'red' : percentage <= 30 ? 'orange' : '';
        return <span style={{ color: color }}>{percentage}%</span>;
      },
    },
    {
      header: 'Bat. Voltage',
      accessorKey: 'batteryVoltage',
      size: 90,
      style: { textAlign: 'center' },
      cell: ({ row }) => <>{row.original.batteryVoltage && <>{row.original.batteryVoltage} V</>}</>,
    },
    {
      header: 'Humidity',
      accessorKey: 'humidity',
      enableColumnFilter: false,
      size: 70,
    },
    {
      header: 'Temp',
      accessorKey: 'temperatureC',
      enableColumnFilter: false,
      size: 60,
    },
    {
      header: 'Light',
      accessorKey: 'light',
      enableColumnFilter: false,
      size: 60,
    },
    {
      header: 'Press',
      accessorKey: 'pressure',
      enableColumnFilter: false,
      cell: ({ row }) => <>{row.original.pressure ?? ''}</>,
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 'auto',
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
  ] as Array<any>;

  return col;
};
